import * as React from 'react';

function CompetencyBlockIcon(props: React.SVGProps<SVGSVGElement>) {
	return (
		<svg width={24} height={24} viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...props}>
			<path
				d="M19.667 22.001h-16A2.667 2.667 0 011 19.334v-12a2.667 2.667 0 012.667-2.667h4v-2c0-.369.299-.667.667-.667H15c.369 0 .667.298.667.667v2h4a2.667 2.667 0 012.667 2.666v12.001a2.667 2.667 0 01-2.667 2.667zM5 6.001H3.666c-.736 0-1.333.597-1.333 1.333v12c0 .737.597 1.334 1.333 1.334H5V6.001zm9.334-2.666H9V4.67h5.334V3.335zM17 6.001H6.333v14.667H17V6.001zm4 1.333C21 6.598 20.403 6 19.667 6h-1.333v14.667h1.333c.736 0 1.333-.597 1.333-1.333V7.334z"
				fill="#6C7680"
				fillRule="nonzero"
			/>
		</svg>
	);
}

export default CompetencyBlockIcon;
